let mostPreferedLanguage = globalThis.navigator.languages[0]
if (mostPreferedLanguage === "de") {
  if ((1.1).toString().indexOf(".") > -1) {
    mostPreferedLanguage = "de-ch"
  }
}
if (mostPreferedLanguage.indexOf("-") < 0) {
  mostPreferedLanguage = mostPreferedLanguage + "-" + mostPreferedLanguage
}
let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

const date = new Date()
const formatter = new Intl.DateTimeFormat(mostPreferedLanguage, {
  day: "numeric",
  month: "numeric",
})
const formattedParts = formatter.formatToParts(date)
const dayFirst = formattedParts[0].type === "day"

export let displayFormats = {
  dateSpecifics: { dayFirst },
  mostPreferedLanguage,
  decimal: {
    default: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    _4Digits: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }),
    _3Digits: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }),
    _0Digits: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  },
  int: {
    default: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 1,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _16DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 4,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _8DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 4,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _6DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 4,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _5DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 4,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _4DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 4,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _3DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 3,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
    _2DigitsInteger: new Intl.NumberFormat(mostPreferedLanguage, {
      minimumIntegerDigits: 2,
      useGrouping: false,
      minimumFractionDigits: 0,
    }),
  },

  date: {
    default: new Intl.DateTimeFormat(mostPreferedLanguage, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }),
    _2DigitsYear: new Intl.DateTimeFormat(mostPreferedLanguage, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }),
    _4DigitsYear: new Intl.DateTimeFormat(mostPreferedLanguage, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }),
    defaultTimestamp: new Intl.DateTimeFormat(mostPreferedLanguage, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
    }),

    timestampWithoutSecond: new Intl.DateTimeFormat(mostPreferedLanguage, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    }),
  },
}
